import { ActionButton } from "../../design-system/concept/action-button";
import { useEffect, useState } from "react";

// Buttons to grant permissions camera and gyroscope
export interface Granted {
  gyro: boolean;
}

interface PermissionsProps {
  updated: (granted: Granted) => void;
}

export const Permissions: React.FC<PermissionsProps> = ({ updated }) => {
  const [granted, setGranted] = useState<Granted>({
    gyro: false,
  });
  const [gyro, setGyro] = useState(false);
  const [denied, setDenied] = useState(false);
  const [showGyro, setShowGyro] = useState(false);
  const message = `Oops, you may have clicked deny previously to reset please clear website data \n\n Open settings for you phone then go to \n\n Safari -{">"} Advanced -{">"} Website data \n\n Clear data for ${window.location.hostname} `;

  const checkGyroAlreadyGranted = async () => {
    if (gyro === true) {
      return;
    }
    await requestGyro();
  };

  const requestGyro = async () => {
    try {
      console.log("Requesting permission");
      // If the device supports the DeviceOrientationEvent and the requestPermission function, ie IOS 13+ devices
      if (
        DeviceOrientationEvent !== undefined &&
        typeof (DeviceOrientationEvent as any).requestPermission === "function"
      ) {
        console.log("Requested permission");

        const permission = await (DeviceMotionEvent as any).requestPermission();
        console.log("Requested permission");

        if (permission === "granted") {
          setGyro(true);
          setGranted({ ...granted, gyro: true });
          setShowGyro(false);
          updated({ ...granted, gyro: true });
        } else {
            alert(message)
          //alert("Permission denied")
          setDenied(true);
          setGyro(false);
          setGranted({ ...granted, gyro: false });
          setShowGyro(true);
        }
      }else{
           // ON android and laptops etc 
            setDenied(false);
            setGyro(true);
            setGranted({ ...granted, gyro: true });
            setShowGyro(false);
        }
    } catch (e) {
      // alert("Error requesting permission"+ e)
      console.log("Requested permission");

      setGyro(false);
      setGranted({ ...granted, gyro: false });
      setShowGyro(true);
    }
  };

  useEffect(() => {
    if (!gyro) {
      checkGyroAlreadyGranted();
    } else {
      updated({ ...granted, gyro: true });
    }
  }, [gyro]);
  if (!showGyro) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground/40 p-6">
      <div className="flex w-full max-w-md flex-col items-center gap-4 rounded-lg border border-border bg-card p-8 text-center">
        {showGyro && (
          <>
            {denied ? (
              // Pre-line rather than an HTML string: the old code called
              // .replace('\n', '<br/>') on text React renders escaped, so
              // readers saw a literal <br/> in the middle of the sentence.
              <p className="whitespace-pre-line text-sm text-destructive">{message}</p>
            ) : (
              <p className="text-sm text-foreground-soft">
                For the best results we use your phone's gyroscope. Grant
                permission below and accept the prompt.
              </p>
            )}
            <ActionButton
              variant="primary"
              disabled={denied}
              onClick={requestGyro}
              className="px-6 py-3 text-sm"
            >
              Grant permission
            </ActionButton>
          </>
        )}
      </div>
    </div>
  );
};
